<app-card-table
    #personRestrictionTable
    [tableTitle]="'person.restriction.labelMulti'"
    [items]="items"
    [gridData]="items?.length ? undefined : store.data.getPersonContacts()"
    [columns]="columns"
    [refreshCallback]="store.api.getPersonContacts"
    [refreshCallbackFragment]="personContactFrag"
    [additionalFilter]="additionalFilters()"
    translatePrefix="person.restriction."
    [hideCheckboxes]="true"
    (deleteCallbackWithEvent)="deletePersonRestriction($event)"
    (createCallback)="personRestrictionsDetail()"
    (detailCallback)="personRestrictionsDetail($event)"
    [showDetail]="!!personId() && canEdit()"
    [showDelete]="canEdit()"
    [showCreate]="canEdit()"
>
    <ng-template pTemplate="restrictionType" let-item="item">
        {{ 'person.enum.restriction.' + item.subType | translate }}
    </ng-template>
</app-card-table>
